<template>
  <vue-apex-charts
    ref="keywordsearchChartLine"
    type="line"
    height="550"
    :options="chartOptionsLine"
    :series="series"
  />
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: "KeywordsearchChartLine",
  components: {
    VueApexCharts,
  },
  data() {
    return {
      chartOptionsLine: {
        chart: {
          height: 500,
          type: "line",
          stacked: false,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        plotOptions: {
          line: {
                dataLabels: {
                  position: 'top'
                },
              }
        },
        dataLabels: {
          enabled: false,
          fontFamily: "NanumBarunGothic !important",
          textAnchor: 'middle',
          formatter: function (val) {
                return Math.round(val*10)/10 + "%"
              },
          offsetY: -5,
          background: {
            enabled: false
          },
          dropShadow: {
            enabled: true
          }
        },
        stroke: {
          width: 1.5,
          curve: 'smooth',
        },
        markers: {
          size: 4,
          hover: {
            size: 5
          }
        },
        xaxis: {
          categories: [],
        },
        yaxis: [
          {
            axisTicks: {
              show: false,
            },
            axisBorder: {
              show: false,
              color: "#008FFB",
            },
            labels: {
              style: {
                colors: "#008FFB",
              },
              formatter(value) {
                return Math.round(value * 100) / 100;
              },
            },
            title: {
              text: 'Search Volumn',
              style: {
                color: "#008FFB",
              },
            },
            tooltip: {
              enabled: false,
            },
          },
        ],
        legend: {
          position: "top",
          horizontalAlign: "left",
          fontSize: "10px",
          itemMargin: {
            horizontal: 20,
            vertical: 10,
          },
        },
        noData: {
          text: '분석중...',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: '#1817E7',
            fontSize: '20px',
            fontFamily: "NanumBarunGothicB"
          }
        },
      },

      series: [],
    };
  },
  props: {
    keywordsearchChartLine: {
      type: Array,
      default: () => [],
    },
    lineChartCategories: {
      type: Array,
      default: () => [],
    },
    lineChartDesc: {
      type: Array,
      default: () => [],
    },
    isChartInit: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    keywordsearchChartLine(newVal) {
      
      if (!this.isChartInit) {
        const keywordsearchChartLineOption = {
          noData: {
            text: '분석중...',
            style: {
              color: '#1817E7',
            }
          },
        };
        this.series = [];
        this.$refs.keywordsearchChartLine.updateOptions(keywordsearchChartLineOption, true);
        return;
      }


      if(this.lineChartDesc.length > 0){
        this.setValues(newVal, this.lineChartCategories, this.lineChartDesc)
      }
    },
  },
  methods: {
    setValues(newVal, newCategories, newDesc){
      const keywordsearchChartLineOption = {
        xaxis: {
          categories: newCategories,
        },
        tooltip: {
          followCursor: true,
          // fixed: {
          //   enabled: true,
          // },
          custom: function({seriesIndex, dataPointIndex}, description=newDesc) {    
            var freq = parseFloat(description[dataPointIndex]).toLocaleString()        
            return '<div class="arrow_box" style="font-family: NanumBarunGothic !important; font-size: 0.9rem;">' +
             '<span>' + freq + '%</span>' +
             '</div>'
          }
        }



      };
      this.series = newVal;
      this.$refs.keywordsearchChartLine.updateOptions(keywordsearchChartLineOption, true);

    }
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/chart-apex.scss";

// .arrow_box {
//   position: relative;
//   background: $secondary;
//   border-radius: 7%;
// }

.arrow_box {
  color: #333;
  background: #fff;
  border: 1px solid #F2F2F2;
  font-family: "NanumBarunGothic", Arial, sans-serif !important;
  filter: none;
  box-shadow: 1px 1px 1px #F2F2F2;
  font-weight: bold;
}

</style>
  